import styled from 'styled-components'
import Icon from '@mdi/react'

import { accountMenuItemCss } from 'components/AccountMenu/AccountMenuNav/styles'
import theme from 'theme_'

export const StyledMiniCompanyItem = styled.button`
  ${accountMenuItemCss}
  position: relative;
  z-index: 1;
  padding-right: 33px;
  padding-left: ${theme.spacing.s};
  border-bottom: 1px solid ${theme.colors.lightGrey};
  cursor: pointer;
`

export const StyledMiniCompanyImgWrap = styled.div`
  flex: none;
  width: 55px;
  height: 38px;
`

export const ActiveCompanyMultiArrow = styled(Icon)`
  position: absolute;
  z-index: 2;
  right: 0;
  top: 4px;
  color: ${theme.colors.horizonOrange};
`
